import { useMediaQuery, useTheme } from '@mui/material';
import cx from 'classnames';
import React from 'react';
import { useChannelStateContext } from 'stream-chat-react';
import { makeStyles } from 'tss-react/mui';

import { MENU_LOGO_WIDTH } from 'src/features/drawer/MenuLogo';
import { Action, BaseActionsMenu } from 'src/legacy/components/Dropdowns';
import { ChannelDetailsSearchbar } from 'src/legacy/components/SearchInput/Searchbox';

const useStyles = makeStyles()((theme) => ({
  actions: {
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden',
  },
  actionsGap: {
    gap: theme.spacing(1.5),
  },
  actionsShrink: {
    flexShrink: 0,
    '& .MuiInputBase-root': {
      boxSizing: 'content-box',
    },
  },
}));

const LEFT_PADDING = 19;

type Props = {
  actions: Action[];
  messageSearchQuery: string;
  setMessageSearchQuery: (query: string) => void;
  setGroupMemberDropdownAnchor: (element: HTMLElement | null) => void;
  toolbarElement: HTMLDivElement | null;
};

export const MessageDetailsActions: React.FC<Props> = ({
  actions,
  setGroupMemberDropdownAnchor,
  setMessageSearchQuery,
  messageSearchQuery,
  toolbarElement,
}) => {
  // width of search input when expanded
  const [fullSearchWidth, setFullSearchWidth] = React.useState(0);
  const actionWrapperRef = React.useRef<HTMLDivElement>(null);
  const { classes } = useStyles();
  const theme = useTheme();
  const { messages } = useChannelStateContext();
  const isSmDown = useMediaQuery(theme.breakpoints.down('sm'));
  const isExtraSmallViewport = useMediaQuery(theme.breakpoints.down('xs'));

  React.useLayoutEffect(() => {
    const getSearchExpandWidth = () => {
      const toolbarWidth = toolbarElement?.clientWidth || 0;
      const actionWrapperWidth = actionWrapperRef.current?.clientWidth || 0;

      // space between search icon and left toolbar start
      const widthValue =
        toolbarWidth -
        actionWrapperWidth -
        (LEFT_PADDING + (isSmDown ? MENU_LOGO_WIDTH : 0));
      setFullSearchWidth(widthValue);
    };
    getSearchExpandWidth();
    window.addEventListener('resize', getSearchExpandWidth);
    return () => window.removeEventListener('resize', getSearchExpandWidth);
  }, [toolbarElement, actionWrapperRef.current, isSmDown]);

  return (
    <div
      className={cx(classes.actions, classes.actionsShrink, {
        [classes.actionsGap]: actions && actions.length > 0,
      })}
      ref={actionWrapperRef}
    >
      {!isExtraSmallViewport && messages && messages.length > 0 && (
        <ChannelDetailsSearchbar
          setQuery={setMessageSearchQuery}
          query={messageSearchQuery}
          expandWidth={fullSearchWidth}
        />
      )}
      <BaseActionsMenu
        contained
        actions={actions}
        onActionButtonAnchorElSet={setGroupMemberDropdownAnchor}
      />
    </div>
  );
};
